// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c2a8c486","455":"f3a20bba","977":"19c09a1f"}[chunkId] + ".chunk.js";
};